import { get } from 'lodash-es';
import countryList from '../../../../i18n/en-SG/countryCode.json';
export const addressFormatter = (addressObject) => {
  const addressLinesArray = get(addressObject, 'addressLines') ?? [];
  if (addressObject && addressObject.countryCode) {
    addressLinesArray.push(countryList[get(addressObject, 'countryCode')]);
  }
  if (addressObject && addressObject.postalCode) {
    addressLinesArray.push(get(addressObject, 'postalCode'));
  }
  return addressLinesArray.join(', ').replace(/(^,)|(,$)/g, '');
};
export default addressFormatter;
